// src/utils/status.js

export const STATUS_LEVEL = {
  NEW: 1,
  ACTIVATED: 2,
  BRONZE: 3,
  SILVER: 4,
  GOLD: 5,
};

// Base fee for Bronze: 1-10 -> 1, 11-20 -> 2, 21-30 -> 3, ...
export function calculateBaseFee(amount) {
  if (!amount || amount <= 0) return 0;
  return Math.ceil(amount / 10);
}

export function calculateFee(amount, status) {
  if (!amount || amount <= 0) return 0;

  const base = calculateBaseFee(amount);

  if (status >= STATUS_LEVEL.GOLD) {
    return 0; // Gold: free
  }

  if (status >= STATUS_LEVEL.SILVER) {
    return base / 2; // Silver: half fee
  }

  // Bronze or below (only Bronze should be allowed to transfer)
  return base;
}

// Can user transfer/withdraw this amount, given balance?
export function canTransferWithdrawAmount(amount, balance, statusLevel) {
  if (!statusLevel || statusLevel < STATUS_LEVEL.BRONZE) return false;

  const amt = Number(amount);
  if (!amt || amt <= 5) return false;

  const fee = calculateFee(amt, statusLevel);
  const total = amt + fee;

  // Always minimum 5 Euro must stay in wallet
  return balance - total >= 5;
}
